<template>
  <dl class="facility-list">
    <dt>{{ title }}</dt>
    <dd v-for="(option, index) in options" :key="index" class="checkbox-item">
      <label class="label-checkbox">
        <input
          :value="option.value"
          @change="updateValue($event.target.value)"
          :checked="isChecked(option.value)"
          :name="name"
          type="checkbox"
          class="checkbox"
        />{{ option.name }}
      </label>
    </dd>
  </dl>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    title: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    }
  },
  methods: {
    isChecked(value) {
      return this.value.includes(value.toString())
    },
    updateValue(value) {
      if (this.isChecked(value)) {
        this.$emit(
          'input',
          this.value.filter((val) => val !== value)
        )
      } else {
        this.$emit('input', [...this.value, value])
      }
    }
  }
}
</script>
